import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../WorkoutTemplateBuilder'

export default function WorkoutNameInputBox() {
    const { mode, workoutTemplateJSON, mutateWorkout } = useContext(WorkoutTemplateBuilderContext)

    if (mode === 'edit') {
        return (
            <input
                type="text"
                name="workoutName"
                id="workoutName"
                className="w-full bg-white rounded-lg text-base border-0 px-2 py-1 text-gray-900 ring-1 ring-inset ring-stone-400 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6"
                placeholder="Workout Name*"
                defaultValue={workoutTemplateJSON.name}
                onChange={(event) => mutateWorkout('change-workout-name', event.target.value)}
                disabled={false}
            />
        )
    }

    if (mode === 'view') {
        return (
            <div className="flex items-center gap-x-2">
                <input
                    type="text"
                    name="workoutName"
                    id="workoutName"
                    className="w-full flex-grow bg-white rounded-lg text-base border-0 px-2 py-1 text-gray-900 ring-1 ring-inset ring-stone-400 placeholder:text-stone-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6"
                    placeholder="Workout Name*"
                    defaultValue={workoutTemplateJSON.name}
                    disabled={true}
                />

                <p className="text-gray-400 text-xs">v{workoutTemplateJSON.version}</p>
            </div>
        )
    }
}
